import { JobDigitalLogOfflineRange } from '@vitralogy/ng-digital-log';
import moment from 'moment';

export class DigitalLogHelper {

	public static isWithinOfflineRange(timeSlotDate: string, offlineRanges: JobDigitalLogOfflineRange[]): boolean {
		const dateToTest = moment(timeSlotDate).parseZone();

		for (const range of offlineRanges) {
			const startDate = moment(range.startDate).parseZone();
			const endDate = moment(range.endDate).parseZone();

			if (dateToTest.clone().diff(startDate, 'days') >= 0 && dateToTest.clone().diff(endDate, 'days') <= 0) {
				return true;
			}
		}

		return false;
	}
}
